module.exports = __webpack_public_path__ + "static/media/garanties_assistance.5f632ad2.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/aa/documents/adhesion/garanties_assistance.pdf
// module id = 819
// module chunks = 40